import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { officialBadge, ReactSvg } from '../../../../shared/vector-images';

interface VerifiedBadgeProps {
  badgeOnly?: boolean;
}
const VerifiedBadge: FC<VerifiedBadgeProps> = ({ badgeOnly }) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      justifyContent="center"
      flexDirection="column"
      alignItems="center"
      pl="2"
    >
      <ReactSvg
        toDisplay={officialBadge()}
        options={{
          fillColor: theme.colors.success,
        }}
        width={32}
        height={32}
      />
      {!badgeOnly && <Box fontSize="11px">Promoted</Box>}
    </Box>
  );
};

VerifiedBadge.defaultProps = {
  badgeOnly: false,
};

export default VerifiedBadge;
